import { t } from 'Locale';
// Source can be either imported image or in format { url: '' }.
// This can be later used as source for Image component
const createOnboardingItem = (source, titleKey = '', buttonTitleKey = '') => ({
    source,
    getTitle: () => t(titleKey),
    getButtonTitle: () => t(buttonTitleKey)
});

export default createOnboardingItem;
